import React, { useEffect, Dispatch, SetStateAction, useState } from "react";
import { ACTION_DISPLAY_TYPES } from "../../../constants/enums";
import { useHistory } from "react-router-dom";

import PINInputs from "../PINInputs";
import Action from "../../Common/Action";
import i18n from "../../../i18n/config";
import { ROUTES } from "../../../constants/clientRoutes";

const PINCheckBody = ({ handleSubmit, setOpenPinCheckModal, submitting }: { handleSubmit: Function, setOpenPinCheckModal: Dispatch<SetStateAction<boolean>>, submitting: boolean }) => {
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [pinInputValues, setPinInputValues] = useState("");
  const history = useHistory();

  useEffect(() => {
    setDisableSubmit(pinInputValues.length !== 4);
  }, [pinInputValues]);

  return (
    <>
      <PINInputs
        submitFunc={handleSubmit}
        formId={"pin-check"}
        resetValues={false}
        className="spacing-bottom-medium text-center"
        setPinInputValues={setPinInputValues}
      />

      <Action
        displayType={ACTION_DISPLAY_TYPES.TEXT}
        title={i18n.t("COMMON.GO_BACK")}
        onClick={() => setOpenPinCheckModal(false)}
      />

      <Action
        displayType={ACTION_DISPLAY_TYPES.TEXT}
        title={i18n.t("PAGES.MY_CARD.INDEX.PIN_CHECK_MODAL.SUBMIT_BUTTON")}
        onClick={() => handleSubmit(pinInputValues)}
        disabled={disableSubmit}
        loading={submitting}
      />

      <hr className="spacing-top-tiny spacing-bottom-tiny" />

      <div className="flex-row justify-content-center align-items-center">
        <Action
          displayType={ACTION_DISPLAY_TYPES.TEXT}
          title={i18n.t("PAGES.MY_CARD.PIN_CHANGE.FORGOT_PIN")}
          onClick={() => history.push(ROUTES.PIN_FORGOT)}
          className="bold"
        />
      </div>
    </>
  );
}

export default PINCheckBody;